module.exports = __webpack_public_path__ + "img/DIN_DVGW_certificate.275c91ce.jpg";